import { ConfirmActionViewProps } from '@deckManagement/types/KPILibrary.types';
import Box from '@mui/material/Box';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';

import VariantUsageSummary from './VariantUsageSummary';

/**
 * Reusable confirmation view with a message panel and usage summary.
 * Used for both confirm-save and confirm-delete flows.
 */
const ConfirmActionView = ({
  wrapperClassName,
  msgClassName,
  messages,
  usageSummary,
  isUsageSummaryLoading,
  expandedDeckId,
  onExpandChange,
  isDialogMode,
  confirmActions,
}: ConfirmActionViewProps) => (
  <>
    <Box className={wrapperClassName}>
      <Box className={msgClassName}>
        {messages.map((msg) => (
          <Typography key={msg} variant='body1' component='p'>
            {msg}
          </Typography>
        ))}
      </Box>
      <VariantUsageSummary
        usageSummary={usageSummary}
        isLoading={isUsageSummaryLoading}
        expandedDeckId={expandedDeckId}
        onExpandChange={onExpandChange}
      />
    </Box>
    {isDialogMode && <DialogActions>{confirmActions}</DialogActions>}
  </>
);

export default ConfirmActionView;
